<template>
  <div :class="topClasses" @click="showMore">
    <img :src="getBg" />
    <!-- <div class="header-info header-home" v-if="page === 'home'">
      <div class="header-info-title">TO THE FUTURE, SERVICE FIRST</div>
      <div class="header-info-name">
        服务至上
        <span class="bold">臻于未来</span>
      </div>
      <div class="header-info-desc">
        值得信赖的专业数据中心技术服务提供商
      </div>
      <div class="header-info-en">
        Trusted digital transformation solution provider
      </div>
      <div class="header-info-btn">
        了解安易信
      </div>
    </div>

    <div class="header-info header-solution" v-if="page === 'solution' || page === 'introduction'">
      <div class="header-info-title">TO THE FUTURE, SERVICE FIRST</div>
      <div class="header-info-name">
        数字化转型
        <span class="bold">解决方案</span>
      </div>
      <div class="header-info-desc">
        值得信赖的专业数据中心技术服务提供商
      </div>
      <div class="header-info-btn">
        了解更多
      </div>
    </div>

    <div class="header-info header-help" v-if="page === 'help'">
      <div class="header-info-title">TO THE FUTURE, SERVICE FIRST</div>
      <div class="header-info-name">
        服务至上
        <span class="bold">臻于未来</span>
      </div>
      <div class="header-info-desc">
        值得信赖的专业数据中心技术服务提供商
      </div>
      <div class="header-info-btn">
        了解安易信
      </div>
    </div>

    <div class="header-info header-examples" v-if="page === 'examples'">
      <div class="header-info-name">
        <div>致力成为</div>
        <div class="bold">客户值得信赖的</div>
        <div>数字化转型技术服务提供商</div>
      </div>
      <div class="header-info-en">
        Tailor to build a leading industry Solution Specialist
      </div>
    </div>

    <div class="header-info header-about" v-if="page === 'about'">
      <div class="header-info-title">ABOUT US , 关于我们</div>
      <div class="header-info-desc">
        专业技术团队，为客户信息化平台保驾护航
      </div>
      <div class="header-info-name">
        <span class="bold">真诚</span>
        进取、合作
        <span class="bold">创新</span>
        。
      </div>
      <div class="header-info-desc">
        致力成为客户值得信赖的专业数据中心技术服务提供商
      </div>
      <div class="header-info-sub">
        服务至上，臻于未来
      </div>
    </div> -->
  </div>
</template>

<script>
import { getBannerData } from '../services'
export default {  
  props: {
    page : {
      type: String,
      required: true
    }
  },

  data () {
    return {
      bgMap: {}
    }
  },

  created () {
    getBannerData().then((res) => {
      const bgMap = {}
      res.data.data.data.children.forEach(item => {
        bgMap[item.name] = 'http://tarzan.minus.live' + item.img
      })
      this.bgMap = bgMap
    })
  },

  methods: {
    showMore: function () {
      switch (this.page) {
        case 'home':
          this.$router.push('/about')
          this.$emit('pageChange', 'about')
          break
        case 'news':
          break
        default:
          // console.log(document.getElementById(`${this.page}1`).getBoundingClientRect())
          // const { top } = document.getElementById(`${this.page}1`).getBoundingClientRect()
          // document.body.scrollTop()
          document.getElementById(`${this.page}1`).scrollIntoView({
            behavior: 'smooth'
          })
          // window.location.hash = `#${this.page}1`
          this.$emit('pageChange', this.page)
      }
    }
  },

  computed: {
    topClasses () {
      return `top ${this.page}`
    },

    getBg () {
      return this.bgMap[this.page]
    }
  },

  watch: {
    '$route': function(route) {
        this.$emit('pageChange', route.name)
    },
  }
}
</script>

<style lang="less" scoped>
  .top {
    width: 100%;
    height: 488px;
    cursor: pointer;
    @media (min-width: 1280px) and (max-width: 1680px){
      height: 732px;
    }
          
    @media screen and (min-width: 1920px){
      height: 732px;
    }

    img {
      width: 100%;
      height: 100%;
    }

    &.home {
      // background: url('../assets/images/top_home.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &.solution, &.introduction {
      // background: url('../assets/images/top_solution.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &.help {
      // background: url('../assets/images/top_help.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &.examples {
      // background: url('../assets/images/top_examples.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &.about {
      // background: url('../assets/images/top_about.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .header-info {
      color: #fff;
      display: flex;
      flex-direction: column;
      &-title {
        font-size: 20px;

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 30px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 40px;
        }
      }

      &-name {
        font-size: 48px;
        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 72px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 96px;
        }

        .bold {
          font-weight: bold;
        }
      }

      &-desc {
        font-size: 12px;

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 18px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 24px;
        }
      }

      &-en {
        font-size: 10px;

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 15px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 20px;
        }
      }

      &-btn {
        width: 96px;
        height: 28px;
        border-radius: 14px;
        background-color: #f45937;
        color: #fff;
        font-size: 9px;
        line-height: 28px;
        text-align: center;
        margin-top: 20px;
        cursor: pointer;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 144px;
          height: 42px;
          border-radius: 21px;
          font-size: 14px;
          line-height: 42px;
          margin-top: 30px;
        }
              
        @media screen and (min-width: 1920px){
          width: 192px;
          height: 56px;
          border-radius: 28px;
          font-size: 18px;
          line-height: 56px;
          margin-top: 40px;
        }
      }
    }

    .header-home {
      padding-top: 80px;
      margin-left: 380px;
      align-items: flex-start;
    }

    .header-solution, .header-help {
      padding-top: 80px;
      align-items: center;
    }

    .header-examples {
      padding-top: 80px;
      margin-left: 380px;
      align-items: flex-start;
      background: rgba(199, 77, 53, .8);
      padding: 40px;
      width: 500px;

      .header-info-name {
        font-size: 36px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .header-about {
      padding-top: 80px;
      margin-left: 380px;
      align-items: flex-start;

      .header-info-name {
        margin: 8px 0px;
        padding: 8px;
        font-size: 36px;
        background: rgb(244, 89, 55);

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 54px;
          margin: 12px 0;
          padding: 12px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 72px;
          margin: 16px 0;
          padding: 16px;
        }
      }

      .header-info-sub {
        margin: 4px 0px;
        padding: 4px;
        background: #000;
        font-size: 9px;
        color: #fff;

        @media (min-width: 1280px) and (max-width: 1680px){
          font-size: 13.5px;
          margin: 6px 0;
          padding: 6px;
        }
              
        @media screen and (min-width: 1920px){
          font-size: 18px;
          margin: 8px 0;
          padding: 8px;
        }
      }
    }
  }
</style>